import * as server from '../entries/pages/_page.server.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/+page.server.js";
export const imports = ["_app/immutable/nodes/2.CM-gFMF5.js","_app/immutable/chunks/cL9VaPgy.js","_app/immutable/chunks/C75YQU_W.js","_app/immutable/chunks/B4FYT0oR.js","_app/immutable/chunks/D-5ps19L.js","_app/immutable/chunks/DO7XS9iS.js"];
export const stylesheets = [];
export const fonts = [];
